module.exports = __webpack_public_path__ + "img/c00_buildingtechloom_Normal_ua.13ea3111.webp";